module.exports = __webpack_public_path__ + "img/destination.8438dd60.svg";